module.exports = __webpack_public_path__ + "img/agency_icon.241e530e.png";